// @3dp/ui/bar-height — the fixed bar covers the bottom of the page: publish how much, as --ui-bar-h on <html>.
// shell.css ends the desktop panel above the bar with it (max-height: calc(100vh - var(--ui-bar-h, 0px) - 24px)),
// and a tool may pad or scroll-pad with it. The bar's height is not a constant: pet-tag's bar has a status line and
// a share line that come and go, and every bar grows by the device's bottom inset.
//
// publishHeaderHeight (ship 3, R21) is the same publication for the page's header row, --ui-header-h: the
// switch made the row taller (57 px; 72 with the beta badge), and the desktop panel's budget must leave
// the header's room above it the way it leaves the bar's below — before ship 3 pet-tag's panel passed the
// rule by 1 px with the header uncounted, and the taller row pushed its last control under the bar.
//
// publishBarHeight(bar) / publishHeaderHeight(header) → stop(). `root` and `Observer` are parameters so
// the unit test runs without a DOM.
const publishHeight = (missing, name, el, { root = document.documentElement, Observer = globalThis.ResizeObserver } = {}) => {
  if (!el) throw new Error(missing);
  const publish = () => root.style.setProperty(name, el.offsetHeight + 'px');
  publish();                                   // now: do not wait for the observer's first callback
  if (typeof Observer !== 'function') return () => {};
  const ro = new Observer(publish);
  ro.observe(el);
  return () => ro.disconnect();
};
export function publishBarHeight(bar, opts) { return publishHeight('publishBarHeight: no bar element', '--ui-bar-h', bar, opts); }
export function publishHeaderHeight(header, opts) { return publishHeight('publishHeaderHeight: no header element', '--ui-header-h', header, opts); }
